import * as React from 'react';
import { Avatar, Divider, Grid, Link, List, ListItem, ListItemAvatar, ListItemText, SvgIcon, Typography } from '@material-ui/core';


export class OrganizationPendingStatusNotification extends React.Component<IPortalUserNotificationProps> {

    state = {
        dismissed: false,
    }

    HandleDismissClick = async () => {
        this.props.dismissNotification(this.props.notificationId);
        this.setState({...this.state, dismissed: true});
    }    

    render() {
        return (
            <div>
                {!this.state.dismissed && <div>
                    <ListItem alignItems="flex-start">
                        <ListItemAvatar>
                            <Avatar>S</Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={
                                <React.Fragment>
                                    <Link href={this.props.url}>
                                        {this.props.title}</Link>
                                    <div style={{ float: 'right', fontSize: 'smaller', marginLeft:'5px' }}>
                                        {this.props.createdAt.toDateString()}
                                    </div>
                                </React.Fragment>}
                            secondary={
                                <React.Fragment>
                                    {"not yet activated. "}
                                    <Grid container justify="flex-end">
                                        <Link href="#" onClick={this.HandleDismissClick}>Dismiss</Link>
                                    </Grid>
                                </React.Fragment>
                            }
                        />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                </div>}
            </div>
        );
    }
}